import { DocumentsList } from "./DocumentsList";

export default {
  title: "SecurityPortal/Events/DocumentsList",
  component: DocumentsList,
  decorators: [
    (Story) => (
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          height: "260px",
          width: "554px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <DocumentsList {...args} />;

export const Default = Template.bind({});
Default.args = {
  onUpload: () => alert("onUpload fired."),
  documents: [
    {
      description: "Non-Disclosure Agreement",
      onClick: () => alert("Clicked 'Non-Disclosure Agreement' Document."),
    },
    {
      description: "Venue Floor Plans",
      onClick: () => alert("Clicked 'Venue Floor Plans' Document."),
    },
    {
      description: "Document 2",
      onClick: () => alert("Clicked 'Document 2' Document."),
    },
  ],
};
